import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useStateInRef } from 'seagull';
import { useIoContext, useStoreActions } from '~/contexts';
import { useFrontendLogging } from '~/hooks/useFrontendLogging';
import { buildStripeLoadFailedLog, isStripeScriptLoadFailure } from './useLoadStripe.utils';
/** Loads stripe, and sets a boolean flag in the store if loading fails. */ export const useLoadStripe = ()=>{
    const { reactStripe: { loadStripe }, browser } = useIoContext();
    const [stripeObj, setStripeObj] = useState(null);
    const { setStripeLoadingFailed } = useStoreActions();
    const getReportFrontendLog = useStateInRef(useFrontendLogging());
    const getPathname = useStateInRef(useLocation().pathname);
    useEffect(()=>{
        loadStripe(window.stripePublicToken).then(setStripeObj).catch((err)=>{
            setStripeLoadingFailed(true);
            if (isStripeScriptLoadFailure(err)) {
                getReportFrontendLog()(buildStripeLoadFailedLog({
                    online: browser.readPageLoadStatus().online,
                    pathname: getPathname()
                }));
            } else {
                Sentry.captureException(err);
            }
        });
    }, []);
    return stripeObj;
};
